/**
 * Recursively normalizes nullish values in objects or arrays:
 * - null, undefined, '' → null
 * - string with only spaces → null
 * - non-empty strings are trimmed (leading/trailing whitespace removed)
 * @param {*} value - The value to normalize
 * @returns {*} normalized value
 */
export const normalizeObject = (value) => {
  if (value === null || value === undefined) return null;

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
  }

  if (Array.isArray(value)) {
    return value.map(normalizeObject);
  }

  if (typeof value === 'object') {
    const normalized = {};
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        normalized[key] = normalizeObject(value[key]);
      }
    }
    return normalized;
  }

  return value;
};
